import React from "react";
import imgBg from "../../assets/contract/dontHasResult.png";
import { makeStyles } from "@mui/styles";
import TextTitle from '../../commonStyles/text/textTitle/textTitle';
import { formatTextWithPhoneNumbers } from '../../utils/phoneNumberFormatter';
const useStyles = makeStyles((theme) => {
  return {
    containerDad:{
       marginTop:"24px"
    },
    containerImage: {
      ...theme.custom.flexBox.flexJusCenter,
      marginBottom:"8px"
    },
    textTitle:{
      fontSize:'14px',
      fontWeight:600,
      textAlign:"center",
    }
  };
});

interface DontHasResultProps {
  textMessage: string;
}

const DontHasResult = ({textMessage}: DontHasResultProps) => {
    const classes = useStyles()
  return (
    <div className={classes.containerDad}>
      <div className={classes.containerImage}>
        <img src={imgBg} alt="" />
      </div>
      <TextTitle className={classes.textTitle}>
        {formatTextWithPhoneNumbers(textMessage)}
      </TextTitle>
    </div>
  );
};

export default DontHasResult;
